import React from "react";

const ChevronDownSmallIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0625 5.39583L7 8.60417L3.9375 5.39583",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ChevronDownSmallIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;